import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';

import { SiteFragmentFragment } from 'data/__generated__';

import { SectionContainer } from 'components/DetailsView/Section';
import { DetailFormValue } from 'components/DetailsView';

export const MenuSection = ({ siteDetails }: { siteDetails: SiteFragmentFragment }) => {
    const { register } = useFormContext();
    const { reassortmentFreshFacings, reassortmentOnboardingStockTargets, reassortmentStockTargetRatios } = siteDetails;

    return (
        <SectionContainer title="Menu Fresh" isInitiallyOpen={false}>
            <>
                <div>
                    <Title>Consommation quotidienne moyenne manuelle (à mettre à la main pour l'onboarding)</Title>
                    <InputsContainer>
                        <DetailFormValue
                            label="Entrées"
                            type="number"
                            defaultValue={reassortmentOnboardingStockTargets.starter}
                            step="1"
                            {...register('reassortmentOnboardingStockTargets.starter', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                        <DetailFormValue
                            label="Petites faims"
                            type="number"
                            defaultValue={reassortmentOnboardingStockTargets.smallBites}
                            {...register('reassortmentOnboardingStockTargets.smallBites', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                        <DetailFormValue
                            label="Plats"
                            type="number"
                            defaultValue={reassortmentOnboardingStockTargets.main}
                            {...register('reassortmentOnboardingStockTargets.main', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                        <DetailFormValue
                            label="Désserts"
                            type="number"
                            defaultValue={reassortmentOnboardingStockTargets.dessert}
                            {...register('reassortmentOnboardingStockTargets.dessert', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                    </InputsContainer>
                </div>
                <div>
                    <Title>Facings par catégorie</Title>
                    <InputsContainer>
                        <DetailFormValue
                            label="Entrées"
                            type="number"
                            defaultValue={reassortmentFreshFacings.starter}
                            step="1"
                            {...register('reassortmentFreshFacings.starter', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                        <DetailFormValue
                            label="Petites faims"
                            type="number"
                            defaultValue={reassortmentFreshFacings.smallBites}
                            {...register('reassortmentFreshFacings.smallBites', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                        <DetailFormValue
                            label="Plats"
                            type="number"
                            defaultValue={reassortmentFreshFacings.main}
                            {...register('reassortmentFreshFacings.main', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                        <DetailFormValue
                            label="Désserts"
                            type="number"
                            defaultValue={reassortmentFreshFacings.dessert}
                            {...register('reassortmentFreshFacings.dessert', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                    </InputsContainer>
                </div>
                <div>
                    <Title>Ratio de consommation (1.1 = +10% de produits positionnés)</Title>
                    <InputsContainer>
                        <DetailFormValue
                            label="Lundi"
                            type="number"
                            step="0.01"
                            defaultValue={reassortmentStockTargetRatios.monday}
                            {...register('reassortmentStockTargetRatios.monday', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                        <DetailFormValue
                            label="Mardi"
                            type="number"
                            step="0.01"
                            defaultValue={reassortmentStockTargetRatios.tuesday}
                            {...register('reassortmentStockTargetRatios.tuesday', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                        <DetailFormValue
                            label="Mercredi"
                            type="number"
                            step="0.01"
                            defaultValue={reassortmentStockTargetRatios.wednesday}
                            {...register('reassortmentStockTargetRatios.wednesday', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                        <DetailFormValue
                            label="Jeudi"
                            type="number"
                            step="0.01"
                            defaultValue={reassortmentStockTargetRatios.thursday}
                            {...register('reassortmentStockTargetRatios.thursday', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                        <DetailFormValue
                            label="Vendredi"
                            type="number"
                            step="0.01"
                            defaultValue={reassortmentStockTargetRatios.friday}
                            {...register('reassortmentStockTargetRatios.friday', {
                                valueAsNumber: true,
                                min: 0,
                                required: true,
                            })}
                        />
                    </InputsContainer>
                </div>
            </>
        </SectionContainer>
    );
};

const InputsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    margin-top: 20px;

    & > :not(:first-child) {
        margin-left: 20px;
    }
`;

const Title = styled.div`
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
`;
